import axios from "axios";
import { GetCurrentUser } from "./DefaultFunction";

let user = GetCurrentUser();

export const BASE_DOMAIN = (() => {
  if (
    window.location.hostname === "rabtai.3em.tech" ||
    window.location.hostname === "localhost"
    // window.location.hostname === "5h9s72hc-3000.euw.devtunnels.ms"
  )
    // return "https://localhost:5295/api/";
    return "http://api.rabtai.3em.tech/api/"
  // else return "https://apidms.samba.com.pk/api/"; // production url
  else return "http://api.rabtai.3em.tech/api/"; // UAT url
})();

export const BASE_URL = BASE_DOMAIN;
export const API = axios.create({
  baseURL: BASE_URL,
  // baseURL: BASE_URL,
  timeout: 300000,
  // timeout: 60000,
  httpAgent: true,
});

// interceptor to set the Authorization header for authenticated requests
API.interceptors.request.use((config) => {
  let user = GetCurrentUser();
  if (user && user.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

// another interceptor to exclude the Authorization header for certain requests
API.interceptors.request.use((config) => {
  const excludeAuthHeader = config.excludeAuthHeader;
  if (excludeAuthHeader) {
    delete config.headers.Authorization;
  }
  return config;
});
